import React, {Component} from "react";
import {Link} from "react-router-dom";
import BackEnd from "../../../backend/BackEnd";
import NewTender from "../Tenders/New/NewTender";
import ActiveTender from "../Tenders/Active/ActiveTender";
import UnderwayTender from "../Tenders/Underway/UnderwayTender";
import IncomingTenderRequest from "../TenderRequests/Incoming/IncomingTenderRequest";
import AcceptedTenderRequest from "../TenderRequests/Accepted/AcceptedTenderRequest";
import UnderwayTenderRequest from "../TenderRequests/Underway/UnderwayTenderRequest";
import ArchivedTenderRequest from "../TenderRequests/Archived/ArchivedTenderRequest";
import ArchivedTender from "../Tenders/Archived/ArchivedTender";

class TenderDetails extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        isLoading: false,
        deliveryTypes: [],
        payers: [],
        paymentConditions: [],
        tenderTypes: [],
        backUrlParent: "",
        backUrl: "",
        backUrlName: "",
        tenderData: { data: {} }
    };
    getCatalogs = new BackEnd.Tenders.GetCatalogs(this);
    getTenderData = new BackEnd.Tenders.GetTenderData(this);

    async componentDidMount() {
        let catalogs = await this.getCatalogs.call();

        catalogs.payers.unshift({id: null, isDisabled: null, text: "Нет информации"});
        this.setState({...catalogs});

        await this.fetchTenderData();
    }

    async componentWillReceiveProps(nextProps) {
        const {tenderId} = nextProps.match.params;

        await this.fetchTenderData(tenderId);
    }

    render() {
        const loadingSpinner = <div className="text-center m-t-2">
            <i className="fa fa-circle-o-notch fa-spin fa-4x text-primary"/>
        </div>;
        const tenderCard = this.getTenderCard(this.state.tenderData);

        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            {
                                this.state.isLoading
                                    ? <h1>Загрузка...</h1>
                                    : (
                                        <h1>
                                            <span className="text-muted font-weight-light">
                                                {this.state.backIcon}{this.state.backUrlParent}
                                                {"/ "}
                                                {
                                                    this.state.backUrl
                                                    ? <Link to={this.state.backUrl}>{this.state.backUrlName}</Link>
                                                    : this.state.backUrlName
                                                }
                                                {" /"}
                                            </span> Заказ № {this.state.tenderData.data.tenderNumber}
                                        </h1>
                                    )
                            }
                        </div>
                        <hr className="page-wide-block visible-xs visible-sm"/>
                        {/*<div className="col-xs-12 width-md-auto width-lg-auto width-xl-auto pull-md-right">*/}
                            {/*<div className="btn-group">*/}
                                {/*<button type="button"*/}
                                        {/*className="btn btn-default btn-outline btn-outline-colorless dropdown-toggle"*/}
                                        {/*data-toggle="dropdown">*/}
                                    {/*<i className="fa fa-share-alt"/>*/}
                                {/*</button>*/}
                                {/*<ul className="dropdown-menu dropdown-menu-right">*/}
                                    {/*<li><a href="#">Отправить письмом</a></li>*/}
                                    {/*<li><a href="#">Сохранить в PDF</a></li>*/}
                                {/*</ul>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                        {/*<OverlayTrigger ref={el => this.shareUrlPopoverOverlay = el}*/}
                                        {/*trigger="click" placement="top"*/}
                                        {/*rootClose*/}
                                        {/*overlay={<ShareUrlPopover*/}
                                            {/*url={this.getAbsoluteTenderUrl()}*/}
                                            {/*close={() => this.shareUrlPopoverOverlay.hide()}/>}>*/}
                            {/*<button type="button" className="btn btn-default btn-xs btn-outline btn-outline-colorless">*/}
                                {/*<i className="fa fa-link"/> Ссылка*/}
                            {/*</button>*/}
                        {/*</OverlayTrigger>*/}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-lg-12 col-xl-9">
                        {
                            this.state.isLoading
                                ? loadingSpinner
                                : tenderCard
                        }
                    </div>
                </div>
                {/*<div className="row">*/}
                    {/*<div className="col-md-12">*/}
                        {/*<div className="panel">*/}
                            {/*<div className="panel-body">*/}
                                {/*<ul className="nav nav-tabs nav-tabs-simple nav-xs">*/}
                                    {/*<li className="active">*/}
                                        {/*<a href="#tabs-comments" data-toggle="tab" aria-expanded="true">*/}
                                            {/*Комментарии*/}
                                        {/*</a>*/}
                                    {/*</li>*/}
                                    {/*<li className="">*/}
                                        {/*<a href="#tabs-history" data-toggle="tab" aria-expanded="false">*/}
                                            {/*История*/}
                                        {/*</a>*/}
                                    {/*</li>*/}
                                {/*</ul>*/}
                                {/*<div className="tab-content tab-content-bordered">*/}
                                    {/*<div className="tab-pane fade active in" id="tabs-comments">*/}
                                        {/*<Comments />*/}
                                    {/*</div>*/}
                                    {/*<div className="tab-pane fade" id="tabs-history">*/}
                                        {/*<History />*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                {/*</div>*/}
            </div>
        );
    }

    async fetchTenderData(tenderId = this.props.match.params.tenderId) {
        let tenderData = await this.getTenderData.call({tenderId});

        this.setState({
            ...this.getBackUrl(tenderData),
            tenderData
        });
    }

    getBackUrl(tenderData) {
        if (tenderData.isOperator || tenderData.isClientNetPallet) {
            switch (tenderData.state) {
                case "New":
                    return {
                        backIcon: <i className="px-nav-icon ion-cube"/>,
                        backUrlParent: "Тендеры",
                        backUrl: "/tenders/new",
                        backUrlName: "Новые"
                    };
                case "Active":
                    return {
                        backIcon: <i className="px-nav-icon ion-cube"/>,
                        backUrlParent: "Тендеры",
                        backUrl: "/tenders/active",
                        backUrlName: "Активные"
                    };
                case "Underway":
                    return {
                        backIcon: <i className="px-nav-icon ion-cube"/>,
                        backUrlParent: "Тендеры",
                        backUrl: "/tenders/underway",
                        backUrlName: "В работе"
                    };
                case "Archived":
                    return {
                        backIcon: <i className="px-nav-icon ion-cube"/>,
                        backUrlParent: "Тендеры",
                        backUrlName: "Архив"
                    };
                default:
                    throw new Error();
            }
        } else {
            switch (tenderData.state) {
                case "Incoming":
                    return {
                        backIcon: <i className="page-header-icon ion-arrow-graph-up-right"/>,
                        backUrlParent: "Заказы",
                        backUrl: "/tenderRequests/incoming",
                        backUrlName: "Новые"
                    };
                case "Accepted":
                    return {
                        backIcon: <i className="page-header-icon ion-arrow-graph-up-right"/>,
                        backUrlParent: "Заказы",
                        backUrl: "/tenderRequests/accepted",
                        backUrlName: "Мои торги"
                    };
                case "Underway":
                    return {
                        backIcon: <i className="page-header-icon ion-arrow-graph-up-right"/>,
                        backUrlParent: "Заказы",
                        backUrl: "/tenderRequests/underway",
                        backUrlName: "В работе"
                    };
                case "Archived":
                    return {
                        backIcon: <i className="page-header-icon ion-arrow-graph-up-right"/>,
                        backUrlParent: "Заказы",
                        backUrl: "/tenderRequests/archived",
                        backUrlName: "Архив"
                    };
                default:
                    throw new Error();
            }
        }
    }

    getTenderCard(tenderData) {
        if (tenderData.isOperator || tenderData.isClientNetPallet) {
            switch (tenderData.state) {
                case "New":
                    return <NewTender data={tenderData.data}
                                      deliveryTypes={this.state.deliveryTypes}
                                      payers={this.state.payers}
                                      paymentConditions={this.state.paymentConditions}
                                      tenderTypes={this.state.tenderTypes}
                                      onRemove={() => this.fetchTenderData()}/>;
                case "Active":
                    return <ActiveTender data={tenderData.data}
                                         deliveryTypes={this.state.deliveryTypes}
                                         payers={this.state.payers}
                                         paymentConditions={this.state.paymentConditions}
                                         tenderTypes={this.state.tenderTypes}
                                         onRemove={() => this.fetchTenderData()}/>;
                case "Underway":
                    return <UnderwayTender data={tenderData.data}
                                           deliveryTypes={this.state.deliveryTypes}
                                           payers={this.state.payers}
                                           paymentConditions={this.state.paymentConditions}
                                           tenderTypes={this.state.tenderTypes}
                                           onRemove={() => this.fetchTenderData()}/>;
                case "Archived":
                    return <ArchivedTender data={tenderData.data}
                                           deliveryTypes={this.state.deliveryTypes}
                                           payers={this.state.payers}
                                           paymentConditions={this.state.paymentConditions}
                                           tenderTypes={this.state.tenderTypes}
                                           onRemove={() => this.fetchTenderData()}/>;
                default:
                    return "Не удалось загрузить тендер";
            }
        } else {
            switch (tenderData.state) {
                case "Incoming":
                    return <IncomingTenderRequest data={tenderData.data}
                                                  onRemove={() => this.fetchTenderData()}/>;
                case "Accepted":
                    return <AcceptedTenderRequest data={tenderData.data}
                                                  onRemove={() => this.fetchTenderData()}/>;
                case "Underway":
                    return <UnderwayTenderRequest data={tenderData.data}
                                                  onRemove={() => this.fetchTenderData()}/>;
                case "Archived":
                    return <ArchivedTenderRequest data={tenderData.data}
                                                  onRemove={() => this.fetchTenderData()}/>;
                default:
                    return "Не удалось загрузить тендер";
            }
        }
    }
}

export default TenderDetails;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/Details/TenderDetails.js